import { createActivityWorkoutEntry } from './ActivityWorkoutEntry';
import { createArticleEntry } from './ArticleEntry';
import { createWorkoutTemplateEntry } from './WorkoutTemplateEntry';
import { createDefaultExploreEntry } from './DefaultExploreEntry';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { v1ParamsToV3Params } from './exploreV3Params';
import { ExploreEntryQueryRequest } from './ExploreEntryQueryRequest';
import { createMeditationEntry } from './MeditationEntry';
import { createBreathingEntry } from './BreathingEntry';
import { ExploreEntry, ExploreEntryUnion } from './ExploreEntry';
import { createLinkEntry } from './LinkEntry';
import { createOnlineMeetingEntry } from './OnlineMeetingEntry';
import { createOfflineMeetingEntry } from './OfflineMeetingEntry';
import { ExploreEntryUpcomingQueryRequest } from './ExploreEntryUpcomingQueryRequest';
import { SubscribableEntryUnion } from './SubscribableEntry';
import { createWebinarEntry } from './WebinarEntry';

export function buildExploreEntry(json: Partial<ExploreEntry>): ExploreEntryUnion {
  switch (json.type) {
    case 'article':
      return createArticleEntry(json as any);
    case 'workoutTemplate':
      return createWorkoutTemplateEntry(json as any);
    case 'activityWorkout':
      return createActivityWorkoutEntry(json as any);
    case 'meditation':
      return createMeditationEntry(json as any);
    case 'breathing':
      return createBreathingEntry(json as any);
    case 'link':
      return createLinkEntry(json as any);
    case 'onlineMeeting':
      return createOnlineMeetingEntry(json as any);
    case 'offlineMeeting':
      return createOfflineMeetingEntry(json as any);
    case 'webinar':
      return createWebinarEntry(json as any);
    default:
      return createDefaultExploreEntry(json as any);
  }
}

/**
 * @deprecated Use buildExploreEntry function or hooks instead
 */
export const ExploreEntryBuilder = {
  build: buildExploreEntry,

  find(request: ExploreEntryQueryRequest, signal?: AbortSignal): Promise<ExploreEntryUnion[]> {
    return HttpBackend.get(
      `/coach/explore/v3/entries`,
      v1ParamsToV3Params({ ...request, contentType: 'entry' }),
      signal ? { signal } : undefined,
    ).then((res) => (res ?? []).map((r: any) => buildExploreEntry(r)));
  },

  random(request: ExploreEntryQueryRequest): Promise<ExploreEntryUnion[]> {
    return HttpBackend.get(`/coach/explore/v3/entries/random`, v1ParamsToV3Params({ ...request, contentType: 'entry' })).then((res) =>
      (res ?? []).map((r: any) => buildExploreEntry(r)),
    );
  },

  findOne(id: string): Promise<ExploreEntryUnion> {
    return HttpBackend.get(`/coach/explore/v3/entries/${id}`).then((res) => buildExploreEntry(res));
  },

  upcoming(request?: Omit<ExploreEntryUpcomingQueryRequest, 'type'>): Promise<SubscribableEntryUnion[]> {
    return HttpBackend.get(`/coach/explore/v3/entries/upcoming`, v1ParamsToV3Params(request ?? {})).then((res) =>
      (res ?? []).map((r: any) => buildExploreEntry(r) as SubscribableEntryUnion),
    );
  },
};
